import * as React from "react";
const SvgArrowDoubleRight20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m4.707 16.707 6-6 .707-.707-.707-.707-6-6-1.414 1.414L8.586 10l-5.293 5.293 1.414 1.414Zm6 0 6-6 .707-.707-.707-.707-6-6-1.414 1.414L14.586 10l-5.293 5.293 1.414 1.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDoubleRight20Px;
